import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Grid,Stack,Container,Box, CircularProgress } from "@mui/material";
import { Skeleton } from "@mui/material";
import SearchPartTimeJob from "./SearchPartTimeJob";
import { getPartTimeJobPage } from "../../services/PartTimeJobPageService";
import HeroSection from "../../components/common/HeroSection";
import AboutPage from "../../components/common/AboutPage";

const PartTime = () => {
  const { country_id, country_name } = useSelector((state) => state.auth || {});
  const [loading, setLoading] = useState(true);
  const [partTimeData, setPartTimeData] = useState(null);

  useEffect(() => {
    if (!country_id) return; // wait until Redux loads
    setLoading(true);

    const fetchPartTimeData = async () => {
      try {
        const res = await getPartTimeJobPage(country_id);
        if (res?.data?.success && res?.data?.data) {
          setPartTimeData(res.data.data);
        } else {
          setPartTimeData(null);
        }
      } catch (err) {
        console.error("❌ Error fetching Part Time page:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPartTimeData();
  }, [country_id]);

   if (loading) {
    return (
      <Container
        sx={{
          py: { xs: 3, sm: 4, md: 6 },
          px: { xs: 3, sm: 4, md: 6 },
        }}
      >
        <Grid container spacing={2} alignItems="center">

          {/* Left skeleton */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant="text" height={60} width="80%" />
            <Skeleton variant="text" height={30} width="90%" />
            <Skeleton variant="text" height={30} width="85%" />

            <Stack direction="row" spacing={2} mt={3}>
              <Skeleton variant="rounded" width={140} height={45} />
              <Skeleton variant="rounded" width={140} height={45} />
            </Stack>

            <Stack spacing={2} mt={3}>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="75%" />
            </Stack>
          </Grid>

          {/* Right skeleton */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton
              variant="rectangular"
              height={420}
              sx={{ borderRadius: 2 }}
            />
          </Grid>

        </Grid>
      </Container>
    );
  }

  // if (loading)
  //   return (
  //     <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
  //       <CircularProgress color="warning" />
  //     </Box>
  //   );

  if (!partTimeData)
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <p>
          No part-time job data found for {country_name || "selected country"}.
        </p>
      </Box>
    );

  // ✅ Prepare data for components
  const heroTitle = partTimeData.hero_section_title || "";
  const heroSubtitle = partTimeData.hero_section_desc || "";
  const heroImage = partTimeData.hero_section_image || "";
  const heroImageType = partTimeData.hero_section_image_type || "";

  const aboutSection = {
    desc: partTimeData.about_desc,
    image: partTimeData.about_image,
    imageType: partTimeData.about_image_type,
  };

  const searchFilters = partTimeData.search_filters || [];

  return (
    <>
      {/* ✅ Hero Section */}
      <HeroSection
        titleContent={heroTitle}
        subtitleContent={heroSubtitle}
        // buttons={[{ label: "Apply Now" }]}
        heroImage={heroImage}
        heroImageType={heroImageType}
      />

      {/* ✅ Search Section */}
      <SearchPartTimeJob filters={searchFilters} />

      {/* ✅ About Section */}
      {/* <AboutPage
        title={`About Part Time Job<br><span style="color:#000;">In</span> <span style="color:#FF9500;">${
          country_name || "This Country"
        }</span>`}
        desc={aboutSection.desc}
        image={aboutSection.image}
        image_type={aboutSection.imageType}
      /> */}
    </>
  );
};

export default PartTime;
